import Logger from '~/web-frontend-core/devtools/logger';
import { AllLiveMatchesConnector as AllLiveMatchesConnector } from "~/web-frontend-core/api/connector/matches/live/All";
import { ChampionshipLiveMatchesListener as ChampionshipLiveMatchesConnector } from '~/web-frontend-core/api/connector/matches/live/Championship';
import { FavoriteLiveMatchesListener as FavoriteLiveMatchesConnector, FavoriteLiveMatchesMobileListener as FavoriteLiveMatchesMobileConnector } from '~/web-frontend-core/api/connector/matches/live/Favorite';
import { SportLiveMatchesListener as SportLiveMatchesConnector, SportLiveMatchesMobileListener as SportLiveMatchesMobileConnector } from "~/web-frontend-core/api/connector/matches/live/Sport";
import { TopLiveMatchesConnector as TopLiveMatchesConnector, TopLiveMatchesMobileConnector as TopLiveMatchesMobileConnector } from '~/web-frontend-core/api/connector/matches/live/Top';
import { VideoLiveMatchesListener as VideoLiveMatchesConnector, VideoLiveMatchesMobileListener as VideoLiveMatchesMobileConnector } from '~/web-frontend-core/api/connector/matches/live/Video';
import { SingleMatchLiveConnector } from '~/web-frontend-core/api/connector/matches/live/SingleMatch';
// import LiveOutcomesTableMobileConnector from "~/web-frontend-core/api/connector/outcomes/live/TableMobile";
// import LiveOutcomesTableConnector from "~/web-frontend-core/api/connector/outcomes/live/Table";
export class ListenersManager {
    constructor(cfg) {
        this.cfg = cfg;
    }
    subscribe(query) {
        var _a, _b;
        this.unsubscribe(query);
        const Listener = ListenersManager.getConnector(query, !!this.cfg.isMobile);
        if (this.instance instanceof Listener) {
            (_a = this.instance) === null || _a === void 0 ? void 0 : _a.subscribe(query);
            return;
        }
        this.instance = new Listener(this.cfg);
        (_b = this.instance) === null || _b === void 0 ? void 0 : _b.subscribe(query);
    }
    unsubscribe(cfg) {
        if (!this.instance) {
            return;
        }
        Logger.getInstance().log(`${this.instance}: Список Live матчей] Отписка`);
        this.instance.unsubscribe(cfg, 'component');
    }
    static getConnector(query, isMobile) {
        // if (query.matchIds) {
        //    const Connector = isMobile ? LiveOutcomesTableMobileConnector : LiveOutcomesTableConnector;
        //    Logger.getInstance().log(`${Connector.name}: Табличная роспись Live матча - Подписка`);
        //    return Connector;
        // }
        if (query.singleMatch) {
            Logger.getInstance().log(`${SingleMatchLiveConnector.name}: Список Live матчей Спорта - Подписка`);
            // return false ? LiveOutcomesTableMobileConnector : SingleMatchLiveConnector
            return SingleMatchLiveConnector;
        }
        if (query.video) {
            const Connector = isMobile ? VideoLiveMatchesMobileConnector : VideoLiveMatchesConnector;
            Logger.getInstance().log(`${Connector.name}: Список Live матчей с Видео - Подписка`);
            return Connector;
        }
        if (query.favorites) {
            const Connector = isMobile ? FavoriteLiveMatchesMobileConnector : FavoriteLiveMatchesConnector;
            Logger.getInstance().log(`${Connector.name}: Список Избранных Live матчей - Подписка`);
            return Connector;
        }
        if (query.top) {
            const Connector = isMobile ? TopLiveMatchesMobileConnector : TopLiveMatchesConnector;
            Logger.getInstance().log(`${Connector.name}: Список Top Live матчей - Подписка`);
            return Connector;
        }
        if (query.championshipId) {
            Logger.getInstance().log(`${ChampionshipLiveMatchesConnector.name}: Список Live матчей Чемпионата - Подписка`);
            return ChampionshipLiveMatchesConnector;
        }
        if (query.sportId) {
            const Connector = isMobile ? SportLiveMatchesMobileConnector : SportLiveMatchesConnector;
            Logger.getInstance().log(`${Connector.name}: Список Live матчей Спорта - Подписка`);
            return Connector;
        }
        if (query.sportId) {
            const Connector = isMobile ? SportLiveMatchesMobileConnector : SportLiveMatchesConnector;
            Logger.getInstance().log(`${Connector.name}: Список Live матчей Спорта - Подписка`);
            return Connector;
        }
        Logger.getInstance().log(`${AllLiveMatchesConnector.name}: Список Всех Live матчей - Подписка`);
        return AllLiveMatchesConnector;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/matchesList/ListenersManager.js